import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Palette } from "@phosphor-icons/react";

const ESTADOS_DISENO_CONFIG = {
    en_diseno: { label: "En diseño", color: "#71717A", bg: "#FAFAFA" },
    radicado: { label: "Radicado", color: "#2563EB", bg: "#EFF6FF" },
    en_curaduria: { label: "En curaduría", color: "#2563EB", bg: "#EFF6FF" },
    con_observaciones: { label: "Con observaciones", color: "#B45309", bg: "#FFFBEB" },
    aprobado: { label: "Licencia aprobada", color: "#16A34A", bg: "#F0FDF4" },
    rechazado: { label: "Rechazado", color: "#DC2626", bg: "#FEF2F2" },
};
const TIPOS_PROYECTO_LABELS = {
    remodelacion: "Remodelación",
    mantenimiento_edificacion: "Mantenimiento de edificación",
    obra_nueva_tradicional: "Construcción obra nueva — Tradicional",
    steel_frame: "Construcción Steel Frame (LGSF)",
};
const COP = (n) => n ? new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP", maximumFractionDigits: 0 }).format(n) : null;

export default function ServiciosDisenoGeneral() {
    const [servicios, setServicios] = useState(null);
    const [error, setError] = useState("");
    const [filtroEstado, setFiltroEstado] = useState("");

    useEffect(() => {
        api.get("/subscriptions-diseno")
            .then(r => setServicios(r.data))
            .catch(e => setError(e.response?.data?.detail || "No se pudo cargar la información"));
    }, []);

    const filtrados = (servicios || []).filter(s => !filtroEstado || s.estado_diseno === filtroEstado);

    return (
        <div className="max-w-5xl mx-auto p-4 md:p-8" data-testid="servicios-diseno-general-page">
            <div className="overline mb-1" style={{ color: "#0F766E" }}>Todos los clientes</div>
            <h1 className="font-display text-4xl font-black tracking-tighter mb-2">Servicios de diseño</h1>
            <p className="text-sm text-zinc-600 mb-6">Topografía, estudios, diseños técnicos y trámite de licencia. Para crear uno nuevo, entra al cliente y asigna la suscripción "Diseño".</p>

            <div className="flex items-center gap-2 mb-6">
                <label className="overline">Filtrar por estado</label>
                <select value={filtroEstado} onChange={e => setFiltroEstado(e.target.value)} className="input-atia w-48" data-testid="filtro-estado">
                    <option value="">Todos</option>
                    <option value="en_diseno">En diseño</option>
                    <option value="radicado">Radicado</option>
                    <option value="en_curaduria">En curaduría</option>
                    <option value="con_observaciones">Con observaciones</option>
                    <option value="aprobado">Licencia aprobada</option>
                    <option value="rechazado">Rechazado</option>
                </select>
            </div>

            {error && <div className="border border-red-300 bg-red-50 p-4 text-sm text-red-700 font-mono mb-6">{error}</div>}
            {!servicios && !error && <div className="text-sm text-zinc-400">Cargando…</div>}

            {servicios && filtrados.length === 0 && (
                <div className="border border-zinc-200 p-8 text-center text-zinc-400">
                    <Palette size={32} className="mx-auto mb-2" />
                    {servicios.length === 0 ? "No hay servicios de diseño registrados todavía." : "Ningún servicio coincide con ese filtro."}
                </div>
            )}

            {filtrados.length > 0 && (
                <div className="border border-zinc-200 overflow-x-auto">
                    <table className="atia-table">
                        <thead>
                            <tr>
                                <th>Cliente</th>
                                <th>Servicio</th>
                                <th>Tipo</th>
                                <th>Estado</th>
                                <th>Coordinador</th>
                                <th>Presupuesto</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtrados.map(s => {
                                const cfg = ESTADOS_DISENO_CONFIG[s.estado_diseno] || ESTADOS_DISENO_CONFIG.en_diseno;
                                return (
                                    <tr key={s.subscription_id} className="row-link" onClick={() => (window.location.href = `/clients/${s.client_id}`)}>
                                        <td className="font-semibold">{s.razon_social}</td>
                                        <td>{s.nombre_proyecto}</td>
                                        <td className="text-zinc-600 text-xs">{TIPOS_PROYECTO_LABELS[s.tipo_proyecto] || "—"}</td>
                                        <td><span className="text-[10px] font-mono font-bold px-2 py-0.5 border inline-block" style={{ color: cfg.color, background: cfg.bg, borderColor: cfg.color }}>{cfg.label}</span></td>
                                        <td className="text-xs">{s.coordinador_diseno_nombre || <span className="text-zinc-400 italic">Sin asignar</span>}</td>
                                        <td className="font-mono text-xs">{COP(s.presupuesto_total_cop) || "—"}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
